<template>
    <div class="card shadow-sm"
         v-if="isVisible">
        <div class="card-header d-flex align-items-center py-1 px-2">
            <div class="flex-grow-1">
                <strong>排程狀態</strong>
            </div>
        </div>
        <div class="card-body p-2">
            <form v-on:submit.prevent.stop="confirm">
                <p class="text-nowrap mb-1"
                   v-if="reply">
                    已選擇：
                </p>
                <b-form-datepicker class="mb-2"
                                   value-as-date
                                   required
                                   placeholder="請選擇安裝日期"
                                   v-bind:disabled="!isInteractive"
                                   v-model="installation">
                </b-form-datepicker>
                <button class="btn btn-sm btn-block btn-light border"
                        type="submit"
                        v-if="isInteractive"
                        v-bind:class="{ 'btn-loading': isLoading }">
                    ✔️ 🗓️ 確認及排程
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import format from "date-fns/format";

const TaskStageVisibilityMap = new Map(
    [
        ["5ed2f24c5dafc6343ed2aa2d", false],
        ["5ed2f3d352a8f2d15a1f7a67", false],
        ["5ed2f41552a8f2d15a1f7a69", false],
        ["5ed308b127cb2d7684bc3423", false],
        ["5ed309638132e677e36b6e48", false],
        ["5ed30bf79594587e7a8d2178", true],
        ["6000fe508d65ee9ddee9f77f", true],
        ["6000fe658d65ee9ddee9f780", true],
        ["6000fe6c8d65ee9ddee9f781", false],
        ["6000fe738d65ee9ddee9f782", false],
    ]
);

const TaskStageInteractivityMap = new Map(
    [
        ["5ed2f24c5dafc6343ed2aa2d", false],
        ["5ed2f3d352a8f2d15a1f7a67", false],
        ["5ed2f41552a8f2d15a1f7a69", false],
        ["5ed308b127cb2d7684bc3423", false],
        ["5ed309638132e677e36b6e48", false],
        ["5ed30bf79594587e7a8d2178", true],
        ["6000fe508d65ee9ddee9f77f", false],
        ["6000fe658d65ee9ddee9f780", false],
        ["6000fe6c8d65ee9ddee9f781", false],
        ["6000fe738d65ee9ddee9f782", false],
    ]
);

import { BFormDatepicker, } from "bootstrap-vue";
import zhTW from "date-fns/locale/zh-TW";

export default {
    name: "TaskSchedule",
    components: {
        BFormDatepicker,
    },
    props: {
        stage: {
            type: String,
        },
        response: {
            type: Object,
        },
    },
    data () {
        return {
            isLoading: false,
            installation: null,
        };
    },
    computed: {
        taskId () {
            return this.$route.params.taskId;
        },
        isVisible () {
            return TaskStageVisibilityMap.get(this.stage);
        },
        isInteractive () {
            return TaskStageInteractivityMap.get(this.stage);
        },
        reply () {
            return this.response["schedule"] ?? "";
        },
        formattedReply () {
            return this.reply ?
                format(new Date(this.response["schedule"]), "PPPP", { "locale": zhTW }) :
                "";
        },
    },
    methods: {
        async confirm () {
            const { taskId, installation, } = this;
            this.isLoading = true;
            try {
                await this.$store.dispatch(
                    "tasks/schedule",
                    {
                        taskId, installation,
                    }
                );
            } catch (e) {
                console.error(e);
            }
            this.isLoading = false;
        },
    },
    watch: {
        reply (newVal) {
            if (newVal) {
                this.installation = new Date(newVal);
            } else {
                this.installation = null;
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
